// Vista aérea de Ubicaciones: al empezar un gesto sobre un producto hay que
// decidir si la vertical desplaza la lista de la caja o arrastra el producto a
// otra caja. Esta función contesta a "¿hay lista que desplazar?"; si devuelve
// null, la vertical es arrastre.
//
// El desplazamiento a mano existe SOLO por el táctil: el tablero lleva
// touch-action:none para quedarse con el pan y el pinch, así que el dedo no
// puede desplazar la lista por su cuenta y se la movemos nosotros. Con ratón esa
// muleta sobra —la rueda ya desplaza— y encima estorbaba: reservarle la vertical
// dejaba el arrastre muerto hacia abajo, había que sacar el producto de lado y
// solo entonces subía y bajaba.
//
// El segundo caso es peor de leer para el usuario: si la lista no desborda no
// hay scroll posible, el gesto se comía sin mover nada y una caja con dos
// productos parecía sencillamente rota.
//
// Reporte CRUO, 19-ago-2026 (vídeo: arrastrar CERVEZA CRUA a la caja de abajo).
export function listaQueSeDesplaza(scrollEl, pointerType) {
  // Con ratón desplaza la RUEDA (ver el handler de wheel en StockBoard, que deja
  // pasar el scroll nativo sobre una lista que desborda en vez de hacer zoom).
  // Ese reparto es lo que permite que aquí la vertical sea siempre arrastre.
  if (pointerType === "mouse") return null;
  return desbordaVertical(scrollEl) ? scrollEl : null;
}

// El mismo umbral para las dos vías (arrastre y rueda): si cada una decide por su
// cuenta qué es "desbordar", una lista de 1px de más se desplaza con el dedo y no
// con la rueda, o al revés.
export function desbordaVertical(el) {
  return !!el && el.scrollHeight > el.clientHeight + 1;
}
